import { jsx } from "react/jsx-runtime";
import { Strip as Strip$1 } from "@nxt-costco-com/forge-components";
import { generateContent } from "../lib.js";
function Strip({
  entry,
  locale
}) {
  if (!entry) return null;
  const { strip_composition } = entry;
  const stripContent = generateContent(strip_composition, locale, false);
  return /* @__PURE__ */ jsx(Strip$1, { children: stripContent });
}
export {
  Strip
};
